// @flow

import React from 'react';
import LanguageButton from '../languageButton';
import { Box, Flex } from '../../../grid';
import { Label } from './atoms';
import LanguageListItem from './languageListItem.styled';

type Props = {
  code: string,
  label: string,
  activeLanguage: string,
  onSelectLanguage: Function,
};

export default ({
  code,
  label,
  activeLanguage,
  onSelectLanguage,
}: Props) => (
  <LanguageListItem key={code}>
    <Flex alignItems="center">
      {activeLanguage === code && (
        <Box>
          <i className="icon-check" />
        </Box>
      )}
      <LanguageButton
        selected={activeLanguage === code}
        onClick={() => onSelectLanguage(code)}
      >
        {code.toUpperCase()}
        <Label>
          (
          {label}
          )
        </Label>
      </LanguageButton>
    </Flex>
  </LanguageListItem>
);
